<template>
  <div class="public-terms-overlay" v-if="isOpen">
    <div class="public-terms-content">
      <h3 class="public-terms-title">⚠️ ご利用上の注意</h3>

      <div class="public-terms-body">
        <p class="public-terms-warning">
          このブックマーク集は<strong>第三者が作成したもの</strong>です。
        </p>

        <ul class="public-terms-list">
          <li>リンク先の安全性は保証されていません</li>
          <li>フィッシング詐欺サイトや悪意のあるサイトに誘導される可能性があります</li>
          <li>ウイルスやマルウェアに感染するリスクがあります</li>
        </ul>

        <p class="public-terms-advice">
          作成者が不明なブックマークを不用意に利用せず、<br>
          <strong>リンク先のURLを十分に確認してからアクセス</strong>してください。
        </p>

        <div class="creator-info" v-if="snsUrl && snsUsername">
          <v-icon size="18" class="creator-icon">{{ snsIcon }}</v-icon>
          <span>製作者：</span>
          <a :href="snsUrl" target="_blank" rel="noopener noreferrer" class="creator-link">@{{ snsUsername }}</a>
        </div>
        <div class="creator-info creator-unknown" v-else>
          <v-icon size="18" class="creator-icon">mdi-account-question</v-icon>
          <span>製作者：不明（ご利用には注意）</span>
        </div>

        <label class="agreement-label">
          <input type="checkbox" v-model="agreed" class="agreement-checkbox">
          上記の注意事項を理解し、自己責任で利用することに同意します
        </label>
      </div>

      <div class="public-terms-buttons">
        <button class="public-terms-back-button" @click="goBack">戻る</button>
        <button class="public-terms-agree-button" @click="acceptTerms" :disabled="!agreed">
          同意して利用する
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { setCookie } from '../services/cookieService';

export default {
  name: 'PublicTermsModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    snsUrl: {
      type: String,
      default: ''
    },
    snsPlatform: {
      type: String,
      default: ''
    },
    snsUsername: {
      type: String,
      default: ''
    }
  },
  emits: ['accept', 'back'],
  data() {
    return {
      agreed: false
    };
  },
  computed: {
    snsIcon() {
      const icons = {
        twitter: 'mdi-twitter',
        instagram: 'mdi-instagram',
        facebook: 'mdi-facebook',
        youtube: 'mdi-youtube',
        tiktok: 'mdi-music-note',
        github: 'mdi-github',
        other: 'mdi-account'
      };
      return icons[this.snsPlatform] || 'mdi-account';
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.agreed = false;
      }
    }
  },
  methods: {
    acceptTerms() {
      if (!this.agreed) return;
      // Cookie: 30日間有効
      setCookie('bkms_pub_terms_agreed', 'true', 30);
      this.$emit('accept');
    },
    goBack() {
      this.$emit('back');
    }
  }
};
</script>

<style scoped>
.public-terms-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1300;
}
.public-terms-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 520px;
  max-height: 90vh;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
}
.public-terms-title {
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
  color: #d32f2f;
  font-size: 1.3rem;
}
.public-terms-body {
  margin-bottom: 20px;
  line-height: 1.7;
}
.public-terms-warning {
  margin-bottom: 16px;
  color: #333;
}
.public-terms-list {
  margin-bottom: 16px;
  padding-left: 20px;
  color: #555;
}
.public-terms-list li {
  margin-bottom: 8px;
}
.public-terms-advice {
  margin-bottom: 20px;
  color: #333;
}
.creator-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 0.93rem;
}
.creator-unknown {
  color: #999;
}
.creator-icon {
  color: #555;
}
.creator-link {
  color: #e9937d;
  text-decoration: none;
}
.creator-link:hover {
  text-decoration: underline;
}
.agreement-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  font-size: 0.92rem;
  color: #333;
  line-height: 1.5;
}
.agreement-checkbox {
  margin-top: 3px;
  accent-color: #e9d0ca;
}
.public-terms-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
}
.public-terms-back-button {
  background: none;
  border: 1px solid #ddd;
  border-radius: 50px;
  padding: 10px 24px;
  font-size: 0.95rem;
  cursor: pointer;
  color: #555;
  transition: background-color 0.2s;
}
.public-terms-back-button:hover {
  background-color: #f5f5f5;
}
.public-terms-agree-button {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 50px;
  padding: 10px 24px;
  font-size: 0.95rem;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.2s;
}
.public-terms-agree-button:hover {
  background-color: #d9b6ab;
}
.public-terms-agree-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .public-terms-content {
    padding: 20px;
  }
  .public-terms-title {
    font-size: 1.1rem;
  }
}
</style>
